import {createContext, useEffect, useState} from 'react'
import {getAuth, getConfig} from '../lib/allauth'
import { persistor } from '../../store'
import SplashScreen from '../../components/screens/SplashScreen'

// these are only to allow navigating the site when the backend is down
const DEFAULT_SESSION = {
    "status": 401,
    "data": {
        "flows": [
            {
                "id": "login"
            },
            {
                "id": "signup"
            },
            {
                "id": "provider_redirect",
                "providers": [
                    "microsoft"
                ]
            }
        ]
    },
    "meta": {
        "is_authenticated": false
    }
};

// these are only to allow navigating the site when the backend is down
const DEFAULT_CONFIG = {
    "status": 200,
    "data": {
        "account": {
            "login_methods": [
                "username",
                "email"
            ],
            "is_open_for_signup": true,
            "email_verification_by_code_enabled": false,
            "login_by_code_enabled": false,
            "password_reset_by_code_enabled": false,
            "authentication_method": "username_email"
        },
        "socialaccount": {
            "providers": [
                {
                    "id": "microsoft",
                    "name": "Microsoft",
                    "flows": [
                        "provider_redirect"
                    ],
                    "client_id": "d7ab93da-81b4-4b61-b4a3-ee289b9b2aea"
                }
            ]
        },
        "usersessions": {
            "track_activity": false
        }
    }
};

export const AuthContext = createContext(null)

export function AuthContextProvider(props) {
    const [auth, setAuth] = useState(undefined)
    const [config, setConfig] = useState(undefined)
    const [error, setError] = useState("");

    useEffect(() => {
        function onAuthChanged(e) {
            setAuth(auth => {
                if (typeof auth === 'undefined') {
                    console.log('Authentication status loaded', auth)
                } else {
                    console.log('Authentication status updated', auth)
                }
                return e.detail
            })
        }

        document.addEventListener('allauth.auth.change', onAuthChanged)
        getAuth()
            .then((data) => {
                console.log('pass auth to context', data)                
                setAuth(data); // triggers finally login state
            })
            .catch((e) => {
                console.error('Authentication status session error', e);
                persistor.purge();
                setAuth(DEFAULT_SESSION);
                setError(`Authentication error. ${e.message}`);
            });

        getConfig()
            .then((data) => {
                setConfig(data);
            })
            .catch((e) => {
                console.error('Authentication status config error', e);
                setConfig(DEFAULT_CONFIG);
                setError(`Authentication error. ${e.message}`);
            });


        return () => {
            document.removeEventListener('allauth.auth.change', onAuthChanged)
        }
    }, [])
    const loading = (typeof auth === 'undefined') || config?.status !== 200
    return (
        <AuthContext.Provider value={{auth, config}}>
            {loading
                ? <SplashScreen children={"Loading..."} />
                : (auth === false
                    ? <SplashScreen children={error}/>
                    : props.children)}
        </AuthContext.Provider>
    )
}
